


































import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import Denuncia from '@/model/Denuncia'
import CargaMagistrado from '@/components/commons/CargaMagistrado.vue'
import CargaExpediente from '@/components/commons/CargaExpediente.vue'
import FechaSelect from '@/components/commons/FechaSelect.vue'
import Resolucion from '@/model/Resolucion'
@Component({
  components: { CargaMagistrado, CargaExpediente, FechaSelect },
})
export default class ShowDenuncias extends Vue {
  @Prop({ required: true })
  private denuncia!: Denuncia

  private localInstance: Denuncia = this.denuncia

  imprimirResolucion(resolucion: Resolucion, tipoResolucion?: string) {
    return resolucion?.numero && resolucion?.anio
      ? `${tipoResolucion} ${resolucion.numero} / ${resolucion.anio}`
      : ''
  }

  @Watch('denuncia')
  private onEntidadChange() {
    if (this.denuncia) {
      this.localInstance = JSON.parse(JSON.stringify(this.denuncia))
    }
  }
}
